import { createFileRoute } from '@tanstack/react-router'

import { ProjectDashboardPage } from '@/pages/project-dashboard/ProjectDashboard.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/dashboard',
)({
  component: ProjectDashboardPage,
})
